module.exports = __webpack_public_path__ + "img/gift-2-line.32a1b32b.svg";